export default "__VITE_ASSET__7HCC4_8x__"